/*jslint browser: true, fudge: true, long: true, this: true */
/*global blacksunplc, self, bsComponents */

/**
 * Accordion component
 */
(function () {
    "use strict";

    var arrays = blacksunplc.arrays;                  // import * as arrays from "module:blacksunplc/arrays"
    var classList = blacksunplc.attributes.classList; // import {classList} from "module:blacksunplc/attributes"
    var events = blacksunplc.events;                  // import * as events from "module:blacksunplc/events"
    var security = blacksunplc.security;              // import * as security from "module:blacksunplc/security"
    var classes = blacksunplc.classes;                // import * as classes    from "module:blacksunplc/classes"
    var behaviors = blacksunplc.behaviors;            // import * as behaviors  from "module:blacksunplc/behaviors"
    var objects = blacksunplc.objects;                // import * as objects    from "module:blacksunplc/objects"
    var $$ = blacksunplc.nodes.qsa;                   // import {qsa as $$}   from "module:blacksunplc/nodes"
    var utils = bsComponents.utils;

    var exports = {};

    exports.AccordionBehavior = classes.define({
        /**
         * @this {!exports.AccordionBehavior}
         * @param {!HTMLUListElement} host
         */
        "constructor": function (host) {
            this.host = host;
        },

        "methods": {
            "connectedCallback": function () {
                var lexicalThis = this;

                arrays.forEach($$(".bs-accordion__header button", this.host), function (button) {
                    events.add(button, "click", function (event) {
                        event.preventDefault();
                        lexicalThis.selectAccordion(button);
                    });
                    events.add(button, "keydown", function (event) {
                        utils.commonKeyDown(event, lexicalThis.host, ".bs-accordion__header button");
                    });
                });
                lexicalThis.checkUrlHasHash();
            },

            "checkUrlHasHash": function () {
                var hash = security.safeLocationHash();
                var lexicalThis = this;
                if (hash) {
                    hash = hash.replace("#", "");
                    arrays.forEach($$(".bs-accordion__header button", this.host), function (button) {
                        if (button.getAttribute("aria-controls") === hash) {
                            if (!classList(button).contains("selected")) {
                                lexicalThis.selectAccordion(button);
                            }
                            setTimeout(function () {
                                window.scrollTo({
                                    behavior: "smooth",
                                    left: 0,
                                    top: button.offsetTop
                                });
                            }, 1000);
                        }
                    });
                }
            },

            /**
             * @param {!Element} targetElement
             */
            "slideUp": function (targetElement) {
                targetElement.style.height = "0px";
                setTimeout(function () {
                    classList(targetElement).remove("selected");
                }, 300);
            },

            /**
             * @param {!Element} targetElement
             */
            "slideDown": function (targetElement) {
                classList(targetElement).add("selected");
                targetElement.style.height = "auto";
                var height = targetElement.clientHeight + "px";
                targetElement.style.height = "0px";
                setTimeout(function () {
                    targetElement.style.height = height;
                }, 0);
            },

            /**
             * @param {!Element} targetElement
             */
            "slideToggle": function (targetElement) {
                if (!classList(targetElement).contains("selected")) {
                    this.slideDown(targetElement);
                } else {
                    this.slideUp(targetElement);
                }
            },

            "selectAccordion": function (element) {
                var lexicalThis = this;

                var accordionType = lexicalThis.host.getAttribute("data-type");
                var isHasHash = lexicalThis.host.getAttribute("data-has-hash");

                var id = element.getAttribute("aria-controls");
                var elementClassList = classList(element);

                var targetElement = document.getElementById(id);
                if (isHasHash === "true") {
                    history.pushState(null, "", "#" + id);
                }

                function expandCollapse() {
                    var timeoutMillis = 50;
                    arrays.forEach($$(".bs-accordion__header button.selected", lexicalThis.host), function (accordionItem) {
                        classList(accordionItem).remove("selected");
                        var ariaControls = accordionItem.getAttribute("aria-controls");
                        lexicalThis.slideUp(document.getElementById(ariaControls));
                        accordionItem.setAttribute("aria-expanded", false);
                        timeoutMillis = 500;
                    });
                    setTimeout(function () {
                        lexicalThis.slideDown(targetElement);
                        element.setAttribute("aria-expanded", true);
                        classList(element).add("selected");
                    }, timeoutMillis);
                }


                if (accordionType === "multi") {
                    elementClassList.toggle("selected");
                    lexicalThis.slideToggle(targetElement);
                } else if (accordionType === "noCollapse") {
                    if (elementClassList.contains("selected")) {
                        return;
                    }
                    expandCollapse();
                } else {
                    if (elementClassList.contains("selected")) {
                        elementClassList.remove("selected");
                        lexicalThis.slideUp(targetElement);
                    } else {
                        expandCollapse();
                    }
                }
            }
        }
    });

    exports.slideDown = function (element) {
        exports.AccordionBehavior.prototype.slideDown(element);
    };
    exports.selectAccordion = function (element) {
        exports.AccordionBehavior.prototype.selectAccordion(element);
    };

    /* jshint ignore:start */

    /** @type {(undefined|!exports.AccordionBehavior)} */
    HTMLUListElement.prototype.accordion; // this fails in IE/Edge 7 and below

    /* jshint ignore:end */

    behaviors.define("accordion-list", exports.AccordionBehavior, {"extends": "ul"});

    bsComponents.accordion = objects.freeze(exports);
}());


blacksunplc.events.ready(function () {
    "use strict";

    var arrays = blacksunplc.arrays;                  // import * as arrays from "module:blacksunplc/arrays"
    var classList = blacksunplc.attributes.classList; // import {classList} from "module:blacksunplc/attributes"
    var behaviors = blacksunplc.behaviors;            // import * as behaviors from "module:blacksunplc/behaviors"
    var accordion = bsComponents.accordion;           // import * as accordion from "module:bsComponents/accordion"

    behaviors.whenDefined("accordion-list").then(function () {
        arrays.forEach(document.querySelectorAll(".bs-accordion__header button"), function (button) {
            if (classList(button).contains("selected")) {
                var ariaControls = button.getAttribute("aria-controls");
                setTimeout(function () {
                    accordion.slideDown(document.getElementById(ariaControls));
                }, 0);
            }
        });
    });
});

/* Accordion component end here */